import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=3c46fc5a&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=3c46fc5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46fc5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c46fc5a')) {
      api.createRecord('3c46fc5a', component.options)
    } else {
      api.reload('3c46fc5a', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=3c46fc5a&scoped=true", function () {
      api.rerender('3c46fc5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Statistics.vue"
export default component.exports